import React from "react";
import ProcessingFeeDateRangeReportPage from "./ProcessingFeeDateRangeReportPage";

export default function ProcessingFeeMonthlySummary() {
  return <ProcessingFeeDateRangeReportPage i18nKey="processing_fee_monthly_summary" filterMode="singleDate" />;
}
